module.exports = __webpack_public_path__ + "static/media/profile-pic-default.511696ce.png";